import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import yn from 'yn'

import GuestHeader from './GuestHeader/GuestHeader'
import HeaderRoutes from './HeaderRoutes'
import IuppHeaderDisconnected from './IuppHeaderDisconnected'

const HeaderRouter = ({ profile, refererIsLogin }) =>
  profile ? (
    <HeaderRoutes refererIsLogin={refererIsLogin} />
  ) : yn(process.env.REACT_APP_HEADERIUPP) && !profile ? (
    <IuppHeaderDisconnected profile={profile} />
  ) : (
    <GuestHeader />
  )

HeaderRouter.propTypes = {
  profile: PropTypes.object,
  refererIsLogin: PropTypes.bool
}

const mapStateToProps = state => {
  const { oidc: { user } } = state
  const { profile } = user || {}

  return { profile }
}

export { HeaderRouter }
export default withRouter(connect(mapStateToProps)(HeaderRouter))



// WEBPACK FOOTER //
// ./src/App/Header/HeaderRouter.js